'use strict';

var React = require('react');

var SvgImportStoreMajor = function SvgImportStoreMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.75a.75.75 0 0 0-1.5 0v2.69l-.47-.47a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l1.75-1.75a.75.75 0 0 0-1.06-1.06l-.47.47v-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.893 4.822a.75.75 0 0 1 .36.998l-.753 1.598v1.082a1 1 0 0 0 2 0v-.25a.75.75 0 0 1 1.5 0v.25a1 1 0 0 0 2 0v-.25a.75.75 0 0 1 1.5 0v.25a1 1 0 0 0 2 0v-1.082l-.752-1.598a.75.75 0 1 1 1.357-.64l.776 1.65c.078.166.119.348.119.532v1.138c0 .563-.186 1.083-.5 1.5v5.25a1.75 1.75 0 0 1-1.75 1.75h-7.5a1.75 1.75 0 0 1-1.75-1.75v-5.25a2.489 2.489 0 0 1-.5-1.5v-1.138c0-.184.04-.366.119-.532l.776-1.65a.75.75 0 0 1 .998-.358Zm4.107 6.178c.681 0 1.299-.273 1.75-.715a2.492 2.492 0 0 0 2.25.665v4.3a.25.25 0 0 1-.25.25h-2.25v-1.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1.5h-2.25a.25.25 0 0 1-.25-.25v-4.3a2.511 2.511 0 0 0 2.25-.665 2.493 2.493 0 0 0 1.75.715Z"
  }));
};
SvgImportStoreMajor.displayName = "ImportStoreMajor";

exports.SvgImportStoreMajor = SvgImportStoreMajor;
